/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Skriv något …',
  'fabric.editor.editorAssistiveLabel': 'Huvudsakligt innehållsområde, börja skriva för att ange text.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Öppna hjälpdialogruta',
};
